import { defineDictionary } from "gemi/client";

export const termsNoticeDict = defineDictionary({
  notice: {
    "en-US":
      "By continuing, you agree to the {{terms:[Terms of Use]}} and the {{privacy:[Privacy Policy]}}.",
    "tr-TR":
      "Devam ederek {{terms:[Kullanım Şartları]}} ile {{privacy:[Gizlilik Politikası]}} metinlerini kabul etmiş olursunuz.",
    "de-DE":
      "Indem Sie fortfahren, stimmen Sie den {{terms:[Nutzungsbedingungen]}} und der {{privacy:[Datenschutzerklärung]}} zu.",
    "it-IT":
      "Continuando, accetti i {{terms:[Termini di utilizzo]}} e l'{{privacy:[Informativa sulla privacy]}}.",
    "fr-FR":
      "En continuant, vous acceptez les {{terms:[Conditions d'utilisation]}} et la {{privacy:[Politique de confidentialité]}}.",
    "es-ES":
      "Al continuar, aceptas los {{terms:[Términos de uso]}} y la {{privacy:[Política de privacidad]}}.",
    "ru-RU":
      "Продолжая, вы принимаете {{terms:[Условия использования]}} и {{privacy:[Политику конфиденциальности]}}.",
  },
});
